import React from 'react'
import Invoices from './Common/Invoices'

const NotPaid = () => <Invoices apiEndpoint='/api/invoices/not-paid' />

export default NotPaid
